export const STORE_KEY = '$common'
export const LOAD_COUNTRIES = 'LOAD_COUNTRIES'
export const LOAD_PAYMENT_METHOD_TYPES = 'LOAD_PAYMENT_METHOD_TYPES'
export const LOAD_VULNERABILITY_TYPES = 'LOAD_VULNERABILITY_TYPES'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_PAYMENT_METHOD_TYPES = 'SET_PAYMENT_METHOD_TYPES'
export const SET_VULNERABILITY_TYPES = 'SET_VULNERABILITY_TYPES'
export const RESET_STORE = 'RESET_STORE'
